module.exports = __webpack_public_path__ + "static/media/title-instruction.44a6aff2.png";